import React from 'react';

const Contact = () => {
    return (
        <div className="bg-blue-500 p-12 text-center flex flex-col justify-center items-center" style={{ minHeight: 'calc(100vh - 64px)' }}>
            <h1 className="text-white text-4xl font-bold mb-4">Connect with me</h1>

            <ul className="flex justify-center flex-wrap font-bold">
                <a href="https://www.linkedin.com/in/raihan-presiden-washil-278762209/">
                    <div className="border-2 border-white text-white py-4 px-8 flex flex-col items-center space-y-2 transform transition-all ease-in-out duration-700 hover:scale-110 m-2">
                        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linkedin/linkedin-original.svg" alt="LinkedIn" className="w-12 h-12" />
                        <span className="mt-2">LinkedIn</span>
                    </div>
                </a>
                <a href="https://github.com/presidenwashil">
                    <div className="border-2 border-white text-white py-4 px-8 flex flex-col items-center space-y-2 transform transition-all ease-in-out duration-700 hover:scale-110 m-2">
                        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg" alt="GitHub" className="w-12 h-12" />
                        <span className="mt-2">GitHub</span>
                    </div>    
                </a>
            </ul>
        
        
        
        </div>
    );
}

export default Contact;